import styled from "styled-components";
import { Section , Container as ContainerStyles, SectionTitle, SectionSubTitle, Grid, Btn, BtnFlex} from "../ReUsableStyles";

export const ContactSection = styled.section`
    ${Section};
`;

export const Container = styled.div`
    ${ContainerStyles};
    ${Grid};
    row-gap: 3rem;
`;

export const Title = styled.h2`
    ${SectionTitle};
`;

export const Subtitle = styled.span`
    ${SectionSubTitle};
`;

export const Information = styled.div`
   display:flex;
   margin-bottom: var(--mb-2);

   .icon-wrapper{
       width:2rem;
       color: var(--first-color);
       margin-right: var(--mb-0-75);
   }
   .contact-icon{
     
   }
`;

export const Contacttitle = styled.h3`
    font-size:var(--h3-font-size);
    font-weight: var(--font-medium);
`;

export const ContactSubtitle = styled.span`
   font-size: var(--small-font-size);
   color: bar(--text-color-light);
`;

export const Form = styled.form`
    ${Grid};
`;

export const InputsWrapper = styled.div`
   ${Grid};
`;

export const Input = styled.input`
   width:100%;
   background-color: var(--input-color);
   color: var(--text-color);
   font-family:var(--body-font);
   font-size: var(--normal-font-size);
   border: none;
   outline: none;
   padding: .25rem .5rem .5rem 0;
`;

export const TextArea = styled(Input).attrs({
    as: "textarea"
})`
   
`;

export const ContactContent = styled.div`
   background-color: var(--input-color);
   border-radius: .5rem;
   padding: .75rem 1rem .25rem;
`;

export const Label = styled.label`
    font-size: var(--smaller-font-size);
    color: var(--title-color);

`;
export const SubmitBtn = styled.button`
   ${Btn};
   ${BtnFlex};
   border:none;
   outline:none;
   &:disabled{
       background-color:lightgray;
       cursor: not-allowed;
   }
`;